module.exports = __webpack_public_path__ + "img/play_overlay.d7646ac6.png";